<script>
export default {
    name: 'MoveTimerSlideItem',
    props: ['item'],
    computed: {
        rounds(){
            const rounds = []
            for(let i=0;i<this.item.round_counter;i++) {
                rounds.push(i)
            }
            return rounds
        },
        isRoundMarker(){
            return typeof this.item.round_counter !== 'undefined'
        },
    }
}
</script>

<style scoped>
    .main-wrap{
        height: 100vh;
        position: relative;
    }
    .order{
        left: 0;
        top: 0;
        position: absolute;
    }
    .order h2{
        color: #fff;
    }
    .wrap{
        max-width: 80vw;
    }
    .content{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh
    }
    .content h1{
        color: #fff;
    }
</style>

<template>
    <div class="main-wrap">
        <div class="order">
            <h2>{{item.order}}</h2>
        </div>
        <div class="content">
            <div class="wrap">
                <h1>{{item.title}}</h1>
                <h2 class="note-block script-item" v-if="isRoundMarker">
                    <b-icon icon="arrow-right" variant="success" v-for="round in rounds" :key="round"></b-icon>
                </h2>
            </div>
        </div>
    </div>
</template>